import { z } from "zod";
export var DmaSpaceKind;
(function (DmaSpaceKind) {
    DmaSpaceKind["Protein"] = "Protein";
    DmaSpaceKind["Micelle"] = "Micelle";
})(DmaSpaceKind || (DmaSpaceKind = {}));
export const dmaSpaceKindDtoSchema = z.nativeEnum(DmaSpaceKind);
